module.exports = "pegasus_template/assets/theme6/large/1.jpg";